import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {GROLOG_BASE_URL} from "../../constant/apiConstant";
import axios from "axios";
import moment from "moment";

const useManagementHistory = ({tableName, id}) => {

    const [managementHistoryList, setManagementHistoryList] = useState([]);

    // Set for auth
    const { token, client_id, grolog_account_id, userId } = useSelector(
        (state) => state.auth
    );

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    };


    const doGetBaseUrl = async (endpoint, tkn, params) => {
        const url = GROLOG_BASE_URL + endpoint;
        const method = "GET";
        const headers = { "Authorization": tkn };
        const request = { url, method, headers, params };
        return axios(request);
    };
    const getManagementHistoryList = async () => {
        let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq ${tableName}, primary_key eq ${id}&order=created_at desc`, token)
        const data = res?.data?.payload
        console.log(data)
        if (data != null) {
            setManagementHistoryList(data)
        }
    }

    const fetchData = async () => {
        getManagementHistoryList()
    };

    useEffect(() => {
        if(id){
            fetchData();
        }
    }, [id]);

    const convertToTime = (timestamp) => {
        let time = new Date(timestamp);
        return moment(timestamp).utc().format("HH:mm");
    };

    return {
        convertTimestamp,
        managementHistoryList,
        convertToTime
    }
}

export default useManagementHistory